// extracted by mini-css-extract-plugin
module.exports = {"blockText":"block-text-module--block-text--2JM6D"};